import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import IVCard from '@invideoio/web-shared/components/Card';
import Person from '@components/testimonials/Person';
import Statement from '@components/testimonials/Statement';
import TestimonySourceRating from '@components/testimonials/TestimonySourceRating';

interface TestimonyProps {
  image?: string;
  video?: string;
  videoMask?: string;
  statement: string;
  name: string;
  source?: string;
  ratings?: number;
  wrapperclass?: string;
  testimonySourceRatingClass?: string;
}
const Testimony = (props: TestimonyProps) => {
  const {
    image,
    video,
    statement = '',
    name = '',
    source = '',
    ratings,
    videoMask,
    wrapperclass,
    testimonySourceRatingClass,
  } = props;
  return (
    <IVCard
      className={ivclass(
        'iv-bg-black-4',
        'iv-rounded-30',
        'iv-mr-40 md:iv-mr-25 sm:iv-mr-20',
        'xl:iv-p-40 iv-p-35 sm:iv-p-25',
        'xl:iv-w-[380px] iv-w-[320px] sm:iv-w-[235px]',
        wrapperclass,
      )}
    >
      <Person image={image} video={video} videoMask={videoMask} name={name} />
      <Statement statement={statement} />

      <TestimonySourceRating
        name={name}
        source={source}
        ratings={ratings}
        testimonySourceRatingClass={testimonySourceRatingClass}
      />
    </IVCard>
  );
};

export default Testimony;
